export default {
  suggestedUsers: state => state.suggestedUsers,
  users: state => state.users,
  loading: state => state.loading
}
